export var navClassname = 'nav';
export var pillsClassname = navClassname + "-pills";
export var tabsClassname = navClassname + "-tabs";
export var fillClassname = navClassname + "-fill";
export var itemClassname = navClassname + "-item";
export var linkClassname = navClassname + "-link";
export var fillStyles = {
  flex: '1 1 auto',
  textAlign: 'center'
};
//# sourceMappingURL=constants.js.map